// extracted by mini-css-extract-plugin
module.exports = {"sidzh0c":"sidzh0c","w17uy7jd":"w17uy7jd"};